import { MultiQueryOptions, useSurgeryMetadataQuery, useUnscheduledSurgeriesQuery } from '..'
import { mergeQueryStatuses } from '../shared/queryHelpers'

/**
 * Fetch all unscheduled surgeries and associated metadata and put them in the store.
 *
 * @param options - (Optional) Parameters for the queries, such as skip and refetchInterval.
 */
export function useUnscheduledSurgeriesAndMetadataQueries(options?: MultiQueryOptions) {
    const unscheduledSurgeriesQuery = useUnscheduledSurgeriesQuery(options)

    const folderIds =
        unscheduledSurgeriesQuery.data
            ?.map(surgery => surgery.surgeryOrderDetails.folderId)
            .filter((folderId): folderId is string => typeof folderId === 'string') ?? []

    const surgeryMetadataQuery = useSurgeryMetadataQuery(folderIds, options)

    const queryResults = mergeQueryStatuses(unscheduledSurgeriesQuery, surgeryMetadataQuery)

    return queryResults
}
